export class WebDokuNodeValue {
  group = "";
  caption = "";
  area = "";
  value = "";
  valueKey = "";
}
